import React, { useEffect, useState } from "react";
import moment from "moment";
import { Col } from "reactstrap";
import { Tooltip } from "@mui/material";
import { DesktopTimePicker } from "@mui/x-date-pickers";

import { ReactComponent as InfoIcon } from "assets/img/svg/infoIcon.svg";

import CustomDatePickerV2 from "../../common/commonComponents/CustomDatePicker-V2";
import AAutoComplete from "./../../common/form-fields-mui/AAutoComplete";

import { timepickerStyle } from "../academicTimetable/academicTimetableListView/TimeSelectionForm";

import {
  RESULT_THRESHOLD_TIME_IN_HOURS,
  START_WITHIN_MSG,
  academicTestTime,
} from "./style";
import { TEST_MODE_FOR_9AM } from "./TestForm";
import "./style.css";

const AcademicTestScheduling = ({
  isTimeTableTest,
  basicFormModal,
  basicFormHandler,
  setBasicModal,
  isEditMode,
  isResultDatePassed,
}) => {
  const {
    mode,
    format,
    startDate,
    endDate,
    testEndTime,
    resultDate,
    resultTime,
    isStartWithin,
    evaluationDate,
  } = basicFormModal;

  const [startWithinTimeRange, setStartWithinTimeRange] = useState([]);

  useEffect(() => {
    if (!isEditMode) {
      let currentData = { ...basicFormModal };
      currentData["mode"] = "";
      currentData["startDate"] = "";
      currentData["endDate"] = "";
      currentData["testStartTime"] = "";
      currentData["testEndTime"] = "";
      currentData["resultDate"] = "";
      currentData["resultTime"] = "";
      setBasicModal(currentData);
    } else {
      let currentData = { ...basicFormModal };
      currentData["endDate"] = startDate;
      currentData["testEndTime"] = "";
      setBasicModal(currentData);
    }
  }, [isStartWithin]);

  useEffect(() => {
    if (isStartWithin && startDate) {
      let currentData = { ...basicFormModal };
      currentData["endDate"] = startDate;

      if (basicFormModal?.testStartTime) {
        currentData["testStartTime"] = moment(startDate)
          .set("hour", moment(basicFormModal?.testStartTime).hour())
          .set("minute", moment(basicFormModal?.testStartTime).minute());
      }

      if (testEndTime) {
        currentData["testEndTime"] = moment(startDate)
          .set("hour", moment(testEndTime).hour())
          .set("minute", moment(testEndTime).minute());
      }

      setBasicModal(currentData);
    }
  }, [startDate]);

  useEffect(() => {
    if (isStartWithin && basicFormModal?.testStartTime && testEndTime) {
      const date1 = moment(basicFormModal?.testStartTime),
        date2 = moment(testEndTime);

      const timeDiff = date2.diff(date1, "hours");

      const options = Array.from({ length: timeDiff + 1 }, (_, index) => ({
        label: index === 0 ? 0 : `${index}hr`,
        value: index,
      }));

      setStartWithinTimeRange(options);

      basicFormHandler("", "startWithinTime");
    } else {
      setStartWithinTimeRange([]);
      basicFormHandler("", "startWithinTime");
    }
  }, [basicFormModal?.testStartTime, testEndTime]);

  useEffect(() => {
    if (isStartWithin && resultDate && moment(testEndTime)?.isValid()) {
      if (resultTime) updateResultTime(moment(resultTime));
      else {
        const minDate = moment(evaluationDate || resultDate).add(2, "days");
        basicFormHandler(minDate, "resultTime");
      }
    }
  }, [resultDate]);

  const updateResultTime = (currentValue) => {
    if (!currentValue || !currentValue.isValid()) {
      basicFormHandler("", "resultTime");
      return;
    }

    const referenceDateTime = moment(resultDate)
      .set("hour", currentValue.hour())
      .set("minute", currentValue.minute())
      .toDate();
    // const laterDate = moment.max([minDate, referenceDateTime]);

    basicFormHandler(referenceDateTime, "resultTime");
  };

  return (
    <>
      {!isTimeTableTest &&
        (isStartWithin ? (
          <>
            <Col md={4}>
              <label className="testLabel">Start Time*</label>
              <DesktopTimePicker
                ampm={true}
                disableIgnoringDatePartForTimeValidation
                minTime={moment()}
                value={
                  basicFormModal?.testStartTime
                    ? moment(basicFormModal?.testStartTime, "hh:mm A")
                    : null
                }
                onChange={(value) => {
                  if (!value || !value.isValid()) {
                    basicFormHandler("", "testStartTime");
                    return;
                  }

                  const referenceDateTime = moment(startDate)
                    .set("hour", value.hour())
                    .set("minute", value.minute())
                    .toDate();

                  basicFormHandler(referenceDateTime, "testStartTime");
                }}
                disabled={!startDate || isResultDatePassed}
                sx={{ ...timepickerStyle, width: "100%" }}
              />
            </Col>

            <Col md={4}>
              <label className="testLabel">End Time*</label>
              <DesktopTimePicker
                ampm={true}
                value={testEndTime ? moment(testEndTime, "hh:mm A") : null}
                minTime={moment(basicFormModal?.testStartTime, "hh:mm A").add(
                  "hour",
                  3,
                )}
                onChange={(value) => {
                  if (!value || !value.isValid()) {
                    basicFormHandler("", "testEndTime");
                    return;
                  }

                  const referenceDateTime = moment(endDate)
                    .set("hour", value.hour())
                    .set("minute", value.minute())
                    .toDate();

                  basicFormHandler(referenceDateTime, "testEndTime");
                }}
                disabled={!basicFormModal?.testStartTime || isResultDatePassed}
                sx={{ ...timepickerStyle, width: "100%" }}
              />
            </Col>

            {format?.value === "Subjective" && (
              <Col md={4}>
                <CustomDatePickerV2
                  value={evaluationDate}
                  handler={(index, date) => {
                    let currentData = { ...basicFormModal };
                    currentData["evaluationDate"] = date;
                    currentData["resultDate"] = "";
                    currentData["resultTime"] = "";
                    setBasicModal(currentData);
                  }}
                  label="Evaluation date*"
                  placeHolder="Select evaluation date"
                  minDate={moment(testEndTime).add(24, "hours")}
                  disabled={!testEndTime}
                />
              </Col>
            )}
          </>
        ) : TEST_MODE_FOR_9AM.includes(mode?.value) ? (
          <>
            <Col md={4}>
              <AAutoComplete
                label="Start Time*"
                placeholder="Select start time"
                items={academicTestTime}
                currentValue={basicFormModal?.testStartTime}
                handleChange={(value) => {
                  basicFormHandler(value, "testStartTime");
                }}
                isMulti={false}
                isDisabled={!startDate || isResultDatePassed}
              />
            </Col>
            <Col md={4}>
              <AAutoComplete
                label="End Time*"
                currentValue={testEndTime}
                isMulti={false}
                isDisabled={true}
                // same as the Start Date and must be displayed in read-only mode
                items={academicTestTime || isResultDatePassed}
              />
            </Col>

            {mode?.value !== "Offline" && format?.value === "Subjective" && (
              <Col md={4}>
                <CustomDatePickerV2
                  value={evaluationDate}
                  handler={(index, date) => {
                    let currentData = { ...basicFormModal };
                    currentData["evaluationDate"] = date;
                    currentData["resultDate"] = "";
                    setBasicModal(currentData);
                  }}
                  label="Evaluation date*"
                  placeHolder="Select evaluation date"
                  minDate={moment(endDate).add(24, "hours")}
                  disabled={!testEndTime}
                />
              </Col>
            )}
          </>
        ) : (
          <></>
        ))}

      <Col md={4}>
        {!isTimeTableTest &&
        mode?.value !== "Offline" &&
        format?.value === "Subjective" ? (
          // result gap = 2 days + end Test Time
          <CustomDatePickerV2
            value={resultDate}
            handler={(index, date) => basicFormHandler(date, "resultDate")}
            label="Result date*"
            placeHolder="Select result date"
            minDate={moment(evaluationDate).add(2, "days")}
            disabled={!evaluationDate}
          />
        ) : (
          //   field in both academic/branch Tests
          <CustomDatePickerV2
            value={resultDate}
            handler={(index, date) => {
              if (!date) {
                basicFormHandler("", "resultDate");
                return;
              }

              const resultDate = moment(date).toDate();
              basicFormHandler(resultDate, "resultDate");
            }}
            label="Result date*"
            placeHolder="Select result date"
            minDate={
              mode?.value?.toLowerCase() !== "online"
                ? moment(endDate).add(1, "days")
                : moment(endDate)
            }
            disabled={endDate === ""}
          />
        )}
      </Col>

      {!isTimeTableTest && isStartWithin && (
        <>
          <Col md={4}>
            <label className="testLabel">Result Time*</label>
            <DesktopTimePicker
              ampm={true}
              disableIgnoringDatePartForTimeValidation
              minTime={moment(evaluationDate).add(2, "days")}
              value={
                basicFormModal?.resultTime
                  ? moment(basicFormModal?.resultTime, "hh:mm A")
                  : null
              }
              onChange={updateResultTime}
              disabled={!testEndTime || !resultDate}
              sx={{ ...timepickerStyle, width: "100%" }}
            />
          </Col>

          <Col md={4}>
            <label className="testLabel mr-2">Start within</label>
            <span>
              <Tooltip title={START_WITHIN_MSG}>
                <InfoIcon />
              </Tooltip>
            </span>
            <AAutoComplete
              currentValue={basicFormModal?.startWithinTime}
              isMulti={false}
              isDisabled={!testEndTime || isResultDatePassed}
              items={startWithinTimeRange}
              handleChange={(value) => {
                basicFormHandler(value, "startWithinTime");
              }}
            />
          </Col>
        </>
      )}
    </>
  );
};

export default AcademicTestScheduling;
